export const IQPReviewconfirmationStrings = {
  strings: {
    en: {
      describeSCEReview: 'Please confirm the information below before submitting.',
      householdInformation: 'Household Information',
      totalhouse: 'Total Number in Household',
      adults: 'Adults',
      children: 'Children',
      ContactInformation: 'Contact Information',
      iqpName: 'Name',
      emailAddress: 'Email Address',
      telephoneNumber: 'Telephone Number',
      hearingImpaired: 'Hearing Impaired?',
      agencySourceCode: 'Agency Source Code',
      eligibilityInformation: 'Eligibility Information',
      eligibilitySelection: 'Eligibility Selection',
      qualifyingPrograms: 'Qualifying Programs',
      income: 'Income',
      mailingAddress: 'Mailing Address',
      Reviewerrorheader: 'We’re sorry, we’ve encountered a problem.',
      ReviewErrorMsg: 'This service account is not eligible for either the CARE or FERA programs based on the income information provided. If you feel this is incorrect, please try again, or call 1-XXX-XXX-XXXX.',
      ReviewErrorTenantinfo: 'Tenant Information',
      Thanksyou: 'Thank You!',
      Thankyoupara: 'Your application has been processed, and you are now active. Your monthly discount will start appearing on your next billing statement.',
      resertifyThankYouPara: 'Your application has been processed, and you are now active. Your monthly discount will start appearing on your next billing statement.',
      Thankyoulink: 'www.sce.com/StatusInquiry/TrackRequest.aspx',
      DenrollThankyou: 'Thank you.',
      DenrollThankpara: 'You have ended your enrollment in the CARE/FERA program.',
      ConfirmationTracknu: 'Tracking Number:',
      yes: 'Yes',
      no: 'No',
      publicAssistanceProgram: 'Public Assistance Programs',
      householdIncome: 'Household Income',
      sourceOfIncome: 'Source(s) of Income',
      trackStatusDescription: 'You can check your enrollment status anytime at:',
      trackingNumberdescPartOne: 'Please save the Tracking Number for your records',
      trackingNumberdescPartTwo: 'to check your application status or recertify in CARE/FERA. You can also find the Tracking Number in your confirmation email if you provided your email address.',
      edit: 'Edit',
      backToCAREProgramPage: 'Back to CARE Program Page',
      goToSCE: 'Go to SCE.com',
      print: 'Print Confirmation',
      viewStatus: 'View Enrollment Status',

    },
    es: {
      eligibilityInformation: 'Información de elegibilidad',
      eligibilitySelection: 'Selección de elegibilidad',
      qualifyingPrograms: 'Programas de calificación',
      Reviewerrorheader: 'Lo sentimos, hemos encontrado un problema.',
      ReviewErrorMsg: 'Esta cuenta de servicio no es elegible para los programas CARE o FERA en función de la información de ingresos proporcionada. Si crees que esto es incorrecto, inténtalo de nuevo o llama al 1-XXX-XXX-XXXX.',
      publicAssistanceProgram: 'Programas de asistencia publica',
      householdIncome: 'Ingresos del hogar',
      sourceOfIncome: 'Fuentes de ingresos',
      trackStatusDescription: 'Puede comprobar el estado de su inscripción en cualquier momento en:',
      trackingNumberdescPartOne: 'Guarde el número de seguimiento para sus registros',
      mailingAddress: 'Direccion de correo',
      describeSCEReview: 'Confirma que la siguiente información sea correcta antes de enviarla.',
      householdInformation: 'Información sobre el hogar',
      totalhouse: 'Cantidad de personas en el hogar',
      adults: 'Adultos',
      children: 'Niños',
      income: 'Ingresos',
      ContactInformation: 'Información de contacto',
      ConfirmationTracknu: 'Número de seguimiento',
      iqpName: 'Nombre',
      emailAddress: 'Dirección de correo electrónico',
      telephoneNumber: 'Número de teléfono',
      hearingImpaired: 'Problemas de audición?',
      agencySourceCode: 'Código fuente de la agencia',
      Thanksyou: 'Gracias!',
      Thankyoupara: 'Su solicitud de inscripción ha sido enviada con éxito.',
      trackingNumberdescPartTwo: 'para verificar el estado de su aplicación o recertificar en CARE / FERA. También puede encontrar el Número de seguimiento en su correo electrónico de confirmación si proporcionó su dirección de correo electrónico',
      backToCAREProgramPage: 'Volver a la página del programa de CARE',
      goToSCE: 'Entra a SCE.com',
      viewStatus: 'Ver el estado de inscripción',
      resertifyThankYouPara: 'Su solicitud de certificación Re ha sido enviada con éxito.',
      yes: 'Sí',
      no: 'No',

    },
    zh: {
      describeSCEReview: ': 當您提交前，請確認以下資料正確無誤',
      householdInformation: '家庭資料',
      totalhouse: '家庭總人數',
      adults: '成人',
      children: '兒童',
      ContactInformation: '聯絡資料',
      ConfirmationTracknu: ' 追蹤號碼',
      iqpName: '姓名',
      emailAddress: '電郵地址',
      telephoneNumber: '電話號碼',
      hearingImpaired: '聽障電話',
      agencySourceCode: '機構來源代碼',
      eligibilityInformation: '资格信息',
      eligibilitySelection: '资格选择',
      qualifyingPrograms: '排位赛程序',
      mailingAddress: '邮寄地址',
      income: '收入',
      Reviewerrorheader: '很抱歉，我们遇到了问题。',
      ReviewErrorMsg: '根据提供的收入信息，此服务帐户不符合CARE或FERA计划的资格。 如果您认为这不正确，请再试一次，或致电1-XXX-XXX-XXXX。',
      publicAssistanceProgram: '公共援助计划',
      sourceOfIncome: '收入来源',
      trackStatusDescription: '您可以随时查看您的注册状态：',
      trackingNumberdescPartOne: '请保存跟踪编号以供记录',
      householdIncome: '家庭收入',
      Thanksyou: '谢谢!',
      Thankyoupara: '您的注册申请已成功提交',
      trackingNumberdescPartTwo: '检查您的申请状态或在CARE / FERA重新认证。 如果您提供了电子邮件地址，也可以在确认电子邮件中找到跟踪编号',
      backToCAREProgramPage: '返回 CARE/FERA',
      goToSCE: '前往 SCE.com',
      viewStatus: '查看注册状态',
      resertifyThankYouPara: '您的Re认证申请已成功提交。',
      yes: '是',
      no: '没有',
    },
    ko: {
      eligibilityInformation: '자격 정보',
      eligibilitySelection: '자격의 선택',
      qualifyingPrograms: '자격을 갖춘 프로그램',
      mailingAddress: '우편 주소',
      Reviewerrorheader: '죄송합니다, 우리는 문제가 발생 한 것입니다.',
      ReviewErrorMsg: '이 서비스 계좌는 제공된 소득 정보에 근거하여 CARE 또는 FERA 프로그램에 대한 자격이 없습니다. 이것이 잘못되었다고 생각되면 다시 시도하거나 1-XXX-XXX-XXXX 번으로 전화하십시오.',
      publicAssistanceProgram: '공공 지원 프로그램',
      sourceOfIncome: '수입원',
      income: '소득',
      ConfirmationTracknu: '추적 번호',
      trackStatusDescription: '언제든지 등록 상태를 확인할 수 있습니다 :',
      trackingNumberdescPartOne: '기록을 위해 추적 번호를 저장하십시오.',
      describeSCEReview: '제출하기 전에 아래 정보를 확인하세요. ',
      householdInformation: '가구정보',
      totalhouse: '가구구성원총수',
      adults: '성인',
      children: '자녀 ',
      ContactInformation: '연락처정보',
      iqpName: '이름',
      emailAddress: '이메일주소',
      telephoneNumber: '전화번호',
      hearingImpaired: '청각장애인',
      agencySourceCode: '대행사소스코드',
      householdIncome: '가구 소득',
      Thanksyou: '고맙습니다!',
      Thankyoupara: '등록 신청서가 성공적으로 제출되었습니다.',
      trackingNumberdescPartTwo: '귀하의 신청 상태를 확인하거나 CARE / FERA에서 재 인증하십시오. 이메일 주소를 제공 한 경우 확인 이메일에서 추적 번호를 찾을 수도 있습니다.',
      backToCAREProgramPage: 'CARE/FERA로 돌아가기',
      goToSCE: 'SCE.com으로 가기',
      viewStatus: '등록 상태보기',
      resertifyThankYouPara: '인증 신청서가 성공적으로 제출되었습니다.',
      yes: '예',
      no: '아니',
    },
    vi: {
      describeSCEReview: 'Xin vui lòng xác nhận thông tin sau trước khi nộp.',
      householdInformation: 'Thông Tin về Gia Đình',
      totalhouse: 'Tổng Số Người trong Gia Đình',
      adults: 'Người Lớn',
      children: 'Trẻ Em',
      ContactInformation: 'Thông Tin Liên Lạc',
      ConfirmationTracknu: 'Số Theo Dõi',
      iqpName: 'Tên',
      income: 'Lợi Tức',
      emailAddress: 'Địa Chỉ Email',
      eligibilityInformation: 'Thông tin đủ điều kiện',
      eligibilitySelection: 'Lựa chọn đủ điều kiện',
      qualifyingPrograms: 'Chương trình hội đủ điều kiện',
      telephoneNumber: 'Số Điện Thoại',
      hearingImpaired: 'Lãng Tai',
      agencySourceCode: 'Mã Số Nguồn của Cơ Quan',
      mailingAddress: 'Địa chỉ gửi thư',
      Reviewerrorheader: 'Chúng tôi xin lỗi, chúng tôi đã gặp phải một vấn đề.',
      ReviewErrorMsg: 'Tài khoản dịch vụ này không đủ điều kiện cho các chương trình CARE hoặc FERA dựa trên thông tin thu nhập được cung cấp. Nếu bạn cảm thấy điều này không đúng, vui lòng thử lại hoặc gọi 1-XXX-XXX-XXXX.',
      publicAssistanceProgram: 'Các chương trình trợ cấp xã hội',
      householdIncome: 'Thu nhập hộ gia đình ',
      sourceOfIncome: 'Nguồn thu nhập',
      trackStatusDescription: 'Bạn có thể kiểm tra tình trạng tuyển sinh của bạn bất cứ lúc nào tại địa chỉ:',
      trackingNumberdescPartOne: 'Vui lòng lưu Số theo dõi cho hồ sơ của bạn',
      Thanksyou: 'Cảm ơn bạn!',
      Thankyoupara: 'Đơn đăng ký của bạn đã được gửi thành công',
      trackingNumberdescPartTwo: 'để kiểm tra trạng thái ứng dụng của bạn hoặc xác nhận lại trong CARE / FERA. Bạn cũng có thể tìm thấy Số theo dõi trong email xác nhận nếu bạn đã cung cấp địa chỉ email của mình',
      backToCAREProgramPage: 'Trở Lại CARE/FERA',
      goToSCE: 'Vào SCE.com',
      viewStatus: 'Xem tình trạng tuyển sinh ',
      resertifyThankYouPara: 'Đơn xin chứng nhận Re của bạn đã được gửi thành công.',
      yes: 'Vâng',
      no: 'Không',
    },
  },
  common: ['yes', 'no', 'edit', 'print', 'save']
};
